import React, { Fragment, useRef, useState, useEffect } from 'react';
import styles from './questionHeader.css';
import TopPanel from '../../shared/topPanel/TopPanel';
import { useSelector } from 'react-redux';
import { getFontFamily, getScreenType, resizeListener } from '../../../../../../../utils/func';

/**
 *
 * @type {React.NamedExoticComponent<{readonly statistics?: *, readonly setEventSound?: *, readonly contentColor?: *, readonly statisticsPopup?: *, readonly question?: *}>}
 */
const QuestionHeader = React.memo( ( { question, question: { image, image_desktop }, statistics, statisticsPopup, contentColor, setEventSound } ) => {

    let blockRef = useRef();
    const { calendar } = useSelector( state => state );
    const [ img, setImage ] = useState( '' );
    let ref = useRef();

    useEffect( () => {
        onResize();
        resizeListener( ref.current, onResize );
    }, [] );

    useEffect( () => {
        const npImg = getImageForScreenType();
        if ( npImg ) {
            setImage( {
                background: `url(${ npImg && npImg.url })`
            } );
        }
    }, [ image_desktop, image ] );

    const getImageForScreenType = () => {
        const screenType = getScreenType();
        switch ( screenType ) {
            case 'Desktop' : {
                return image_desktop;
            }
            case 'Mobile': {
                return image;
            }
            default: {
                return image_desktop;
            }
        }
    };

    const onResize = () => {
        const image = getImageForScreenType();
        setImage( {
            background: `url(${ image && image.url })`
        } );
    };

    const getImage = getImageForScreenType();
    const { text, image_position } = question.localization;
    const isCover = ( image_position === 'cover' );
    const fontName = getFontFamily( calendar?.settings?.appearance.font_style ).defaultFont;
    const textBackground = {
        backgroundColor: contentColor.type === 'dark'
            ? 'rgba(0, 0, 0, .5)' : 'rgba(0, 0, 0, .8)'
    };

    return (
        <Fragment>

            { !isCover && getImage ?
                <div
                    ref={ ref }
                    className={ styles.wrapperHeaderHasImage }>

                    { question && question.type !== 'free_text' &&
                    <TopPanel
                        isWithImageTop={ true }
                        question={ question }
                        statistics={ statistics }
                        statisticsPopup={ statisticsPopup }
                        contentColor={ contentColor }
                        setEventSound={ setEventSound }
                    /> }

                    <div className={ styles.HasImageWrap }>

                        <div
                            className={ styles.imageWrap }
                            ref={ node => blockRef = node }
                            style={ {
                                'backgroundImage': img.background,
                                'backgroundSize': 'cover',
                            } }
                        />

                        <p style={ !isCover ? {
                            fontFamily: `${ fontName }`,
                            backgroundColor: `${ textBackground }`
                        } : { fontFamily: `${ fontName }` } }
                           className={ styles.textWrapper }>
                            { text }
                        </p>
                        <div className={ styles.foneWrap }/>

                    </div>
                </div>

                :

                <div ref={ ref } className={ styles.wrapperHeader }>

                    { question && question.type !== 'free_text' &&
                    <TopPanel
                        isWithImageTop={ false }
                        question={ question }
                        statistics={ statistics }
                        statisticsPopup={ statisticsPopup }
                        contentColor={ contentColor }
                        setEventSound={ setEventSound }
                    /> }

                    <div className={ styles.noImageQuestion } style={ textBackground }>
                        <p style={ {
                            fontFamily: `${ fontName }`,
                            backgroundColor: 'transparent',
                            background: 'none'
                        } }
                           className={ styles.textWrapper }>
                            { text }
                        </p>
                    </div>
                </div> }
        </Fragment>
    );
} );

export default QuestionHeader;
